import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./i18n";

import "./index.scss";
import "./styles/base.scss";
import { Amplify } from "aws-amplify";

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.
import { configureAmp } from "src/auth/config";
import { RouteMap } from "src/routing/routes";
import { isSpecificDate } from "src/util";
import AprilFirstFavicon from "src/resources/bart_april_1st.png";

Amplify.configure(configureAmp);

// Easter eggs: swap the favicon at runtime on specific dates. The
// build-time favicon (bart_logo_squared.png, set in webpack.config.js) can't
// react to the visit date, so we override it here for visitors on the day.
if (isSpecificDate(4, 1)) {
  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = AprilFirstFavicon;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RouteMap />
    </BrowserRouter>
  </React.StrictMode>,
);
